// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d1cad382","556":"b745e074","794":"0a563167"}[chunkId] + ".chunk.js";
};